import { APIClient } from "./axiosClient";

const api = new APIClient();
const path = "/plans";

const plansApi = {
  plansPurchaseSucceeded(dataForm: any): Promise<any> {
    const url = `${path}/purchase/succeeded`;
    return api.post(url, dataForm);
  },

  getPlans(params?: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  getPlanDetail(id: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.get(url);
  },

  postPlan(dataForm: any): Promise<any> {
    const url = `${path}`;
    return api.post(url, dataForm);
  },

  putPlan(id: any, dataForm: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm);
  },

  deletePlan(id: any) {
    return api.delete(`${path}/${id}`);
  },
};

export default plansApi;
